module.exports = __webpack_public_path__ + "8b0d0915fa4d043156366b6eafa2228e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_28.jpg
// module id = 1671
// module chunks = 5